import { generateClient } from "aws-amplify/api";
import { createDeliveryRoute, updateDeliveryRoute, deleteDeliveryRoute as removeDeliveryRoute } from "graphql/customs/mutations";
import { getDeliveryRoute as fetchDeliveryRoute, deliveryRoutesByDate } from "graphql/queries";
import { showAlert } from "utils/Alert";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";
import { SEQUENCETYPES } from "utils/Constants";
import { sequenceGenerator } from "utils/Form";
import { getPackages, savePackage } from "./PackagesApi";
import { getTypeCounterByName, increaseTypeCounter } from "./TypeCounterApi";

const API = generateClient();

export const saveDeliveryRoute = async (data, packagesList) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updateDeliveryRoute : createDeliveryRoute;
    let cleanData = cleanUpData(data);
    
    delete cleanData["boxes"];
    cleanData["type"] = "DeliveryRoute";

    let counter;
    if (operationName === "create") {
        counter = await getTypeCounterByName(SEQUENCETYPES.DELIVERY_ROUTE);
        const sequenceNumber = sequenceGenerator(SEQUENCETYPES.DELIVERY_ROUTE, counter);
        cleanData = {
            ...cleanData,
            secuencia: sequenceNumber
        };
    }

    const saveOperation = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData,
        }
    });
    const deliveryRouteId = saveOperation.data.createDeliveryRoute ? saveOperation.data.createDeliveryRoute.id : data.id;

    return getPackages({
        deliveryRouteBoxesId: { eq: deliveryRouteId }
    }).then(async (oldPackages) => {
        const oldPackagesPromises = oldPackages.map((p) => {
            const packageData = {
                ...p,
                deliveryRouteBoxesId: null
            }
            return savePackage(packageData);
        });

        const increasePromise = operationName === "create" ? increaseTypeCounter(counter) : true;
        return Promise.all([...oldPackagesPromises], increasePromise);
    }).then((r) => {
        const packagesPromises = Object.keys(packagesList).map((key) => {
            const boxData = packagesList[key];
            const packageData = {
                ...boxData,
                deliveryRouteBoxesId: deliveryRouteId
            }
            return savePackage(packageData);
        });
        return Promise.all([...packagesPromises]);
    }).then((r) => {
        if (operationName === "create") {
            showAlert("success", `El ruta de entrega se ha creado correctamente con la secuencia #${cleanData.secuencia}`);
        }
    });
};

export const getDeliveryRoutes = async (filter = {}) => {
    const data = await API.graphql({
        query: deliveryRoutesByDate,
        variables: {
            "filter": filter,
            "type": "DeliveryRoute",
            "sortDirection": "DESC"
        },
    })
    return getNotDeletedItems(data, "deliveryRoutesByDate");
}

export const getDeliveryRoute = async (routeId) => {
    let cargoObject = await API.graphql({
        query: fetchDeliveryRoute,
        variables: {
            id: routeId
        }
    });
    return getDataFromResponse(cargoObject, "getDeliveryRoute");
}

export const deleteDeliveryRoute = async (cargoData) => {
    const deletedAsset = await API.graphql({
        query: removeDeliveryRoute,
        variables: {
            input: {
                "id": cargoData.id,
            }
        }
    });

    if (cargoData.boxes && cargoData.boxes.items) {
        const boxesPromises = cargoData.boxes.items.map((box) => {
            const packageData = {
                ...box,
                deliveryRouteBoxesId: null
            }
            return savePackage(packageData);
        })
        await Promise.all(boxesPromises);
    }

    return getDataFromResponse(deletedAsset, "deleteDeliveryRoute");
}